module.exports = __webpack_public_path__ + "media/images/emblems/Oetwil_an_der_Limmat-6798b50de15ac9948c899e6a39c22425.svg";